import { ValueGetterParams } from 'ag-grid-community';
import { memoize } from 'lodash';
import { ProjectPhase } from 'api/project';
import { Field } from 'stores/fields';
import { ProjectTimeTrackingFieldsName as FieldName } from 'utils/project-fields/use-project-native-fields-as-filterable-fields';
import { getBaseValueGetter } from 'utils/value-getter/base-value-getter';
import { ProjectFieldsName } from '../fields';

interface ValueGetter {
  (params: ValueGetterParams): any;
}

const memoizeProjectPhases = memoize(
  (value: ProjectPhase[]) => value,
  (value: ProjectPhase[]) => JSON.stringify(value),
);

export const getValueGetter = (
  field: Pick<Field, 'type' | 'fieldName' | 'metaData'> & {
    fieldType?: string;
  },
): ValueGetter | undefined => {
  if (field.fieldType === 'RATING') {
    return ({ data }) => {
      return {
        value: data?.[field.fieldName],
        scale: (field.metaData as any).ratingScale,
      };
    };
  }
  if (field.fieldName === FieldName.budgetedHours) {
    return ({ data }) => {
      return typeof data?.[field.fieldName] === 'number'
        ? data[field.fieldName] * 60
        : 0;
    };
  }
  if (field.fieldName === FieldName.allocatedHours) {
    return ({ data }) => {
      return typeof data?.[field.fieldName] === 'number'
        ? data[field.fieldName]
        : 0;
    };
  }
  if (field.fieldName === ProjectFieldsName.projectPhases) {
    return ({ data }) => memoizeProjectPhases(data?.[field.fieldName]);
  }

  return getBaseValueGetter(field);
};
